var map = {
	"./arrow_right.svg": 1120,
	"./bag.svg": 1122,
	"./caret_down.svg": 1123,
	"./chevron_down.svg": 1124,
	"./chevron_down_small.svg": 1125,
	"./chevron_left.svg": 1126,
	"./chevron_right.svg": 1127,
	"./chevron_up.svg": 1128,
	"./chevron_up_small.svg": 1129,
	"./close.svg": 1130,
	"./heart.svg": 1131,
	"./info-filled.svg": 1132,
	"./search-no-results.svg": 1133,
	"./search.svg": 1134,
	"./social-logo/apple.svg": 1135,
	"./social-logo/facebook.svg": 1136,
	"./social-logo/google.svg": 1137,
	"./stone-shape/asscher.svg": 1138,
	"./stone-shape/baguette.svg": 1139,
	"./stone-shape/cushion.svg": 1140,
	"./stone-shape/emerald.svg": 1141,
	"./stone-shape/heart.svg": 1142,
	"./stone-shape/marquise.svg": 1143,
	"./stone-shape/oval.svg": 1144,
	"./stone-shape/pear.svg": 1145,
	"./stone-shape/princess.svg": 1146,
	"./stone-shape/radiant.svg": 1147,
	"./stone-shape/round.svg": 1148,
	"./stone-shape/tapered-baguette.svg": 1149,
	"./stone-shape/triangle.svg": 1150,
	"./stone-shape/trillion.svg": 1151,
	"./tag.svg": 1152,
	"./truck.svg": 1153,
	"./user.svg": 1154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1119;